
import type React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

interface SectionCardProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function SectionCard({ title, description, icon, children, className }: SectionCardProps) {
  return (
    <Card className={`w-full shadow-lg transition-all duration-300 ease-in-out hover:shadow-xl ${className}`}>
      <CardHeader>
        <div className="flex items-center space-x-3">
          {icon && <div className="text-primary">{icon}</div>}
          <CardTitle className="text-2xl font-headline">{title}</CardTitle>
        </div>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
}
